// import { Dayjs } from "dayjs";
import { BRAINTREE_AUTH_TOKEN } from "../config/configs";
import { Device } from "../components/templates/broadband/pages/BroadbandCheckoutPage";
import { useLocation } from "react-router-dom";
import { WEB_PORTAL_PRODUCT_TYPES } from "../assets/const/portal.const";
export const selfcareDomainProd = "https://my.boingohotspot.net/login";
export const selfcareDomainDevQaStg = "https://my-dev.boingohotspot.net/login";

/**
 * Validates an email address format
 * @param email The email address to validate
 * @returns A boolean indicating whether the email format is valid
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Splits a paragraph into sentences, removing periods and creating new lines.
 * @param paragraph The input paragraph to process.
 * @returns A string with sentences on separate lines and periods removed.
 */
export function splitParagraphIntoSentences(paragraph: string): string {
  // Split the paragraph into sentences using periods as delimiters
  const sentences = paragraph.split(".");

  // Remove any leading or trailing whitespace from each sentence
  // and filter out any empty sentences
  const trimmedSentences = sentences
    .map((sentence) => sentence.trim())
    .filter((sentence) => sentence.length > 0);

  // Join the sentences with newline characters
  return trimmedSentences.join("<br />");
}

// return selfcare domain
export const getSelfcareUrl = (host: string) => {
  return host.includes(".boingohotspot.net")
    ? selfcareDomainProd
    : selfcareDomainDevQaStg;
};

// Helper function to get base path
export const getBasePathOfSelfcare = () => {
  // Get the path segments
  const pathSegments = window.location.pathname.split("/");
  // Find 'selfcare' in the path if it exists
  const selfcareIndex = pathSegments.findIndex((segment) => segment === "my");

  if (selfcareIndex !== -1) {
    // Return path up to 'my'
    return pathSegments.slice(0, selfcareIndex + 1).join("/");
  }

  return "";
};

//generate random transaction id for signup
export const generateGUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

//validate input for Milstar CC number, exp date, cvv, and postal
export const validateInput = (value: string, regex: RegExp): boolean => {
  return regex.test(value);
};

// save to ANY cookie
export const setCookieBase64 = (
  name: string,
  info: any,
  minutes: number = -1
) => {
  const serializedInfo = btoa(JSON.stringify(info));
  const now = new Date();
  now.setTime(now.getTime() + minutes * 60 * 1000);
  const expires = now.toUTCString();
  const template =
    minutes === -1
      ? `${name}=${serializedInfo};path=/`
      : `${name}=${serializedInfo}; expires=${expires}; path=/`;
  document.cookie = template;
};
// get ANY cookie
export const getCookieBase64 = (name: string) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return atob(match[2]);
  return "";
};

// save to cookie
export const saveToCookie = (info: any) => {
  // Serialize the object and store it in a cookie
  const serializedInfo = JSON.stringify(info);
  document.cookie = `customerData=${serializedInfo};path=/`;
};

// get cookieby name
export const getCookieByName = (name: string) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
  return null;
};

//delete cookie by name
export const deleteCookieByName = (name: string) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};

export const getOrCreateGsid = () => {
  // Check query param which always takes precedence even if different than cookie. if gsid exists and use this gsid and set cookie
  const queryGsid =
    getQueryParam("gsid") || getQueryParam("GSID")?.toLowerCase();
  if (queryGsid) {
    // Set cookie with 15 days expiry
    document.cookie = `web-app-portal-gsid=${queryGsid}; max-age=${
      60 * 60 * 24 * 15
    }; path=/`;
    return queryGsid;
  }
  // Check cookie second in case there is no query string
  const cookieGsid = document.cookie
    .split("; ")
    .find((row) => row.startsWith("web-app-portal-gsid="))
    ?.split("=")[1];

  if (cookieGsid) {
    return cookieGsid;
  }

  // Generate new GSID, if no gsid is found,
  const newGsid = generateGUID();
  document.cookie = `web-app-portal-gsid=${newGsid}; max-age=${
    60 * 60 * 24 * 15
  }; path=/`;
  return newGsid;
};

export const javascriptHide = (selector: string) => {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element: any) => {
    element.style.display = "none";
  });
};

export const javascriptShow = (selector: string) => {
  var elements = document.querySelectorAll(selector);
  elements.forEach((element: any) => {
    const computedStyle = window.getComputedStyle(element);
    if (
      computedStyle.display === "inline" ||
      computedStyle.display === "inline-block"
    ) {
      element.style.display = "inline-block";
    } else {
      element.style.display = "block";
    }
  });
};

export const javascriptOnClick = (selector: string, fun: any) => {
  const elements = document.querySelectorAll(selector);

  // Add a click event listener to each element
  elements.forEach((element) => {
    element.addEventListener("click", fun);
  });
};

export const mapGatewayControllerParameters = (params: any) => {
  const isSmartzoneLogin = Boolean(params.nbiIP && params.uip);
  const isWLCLogin = Boolean(params.switch_url);
  const isVia = !isWLCLogin && !isSmartzoneLogin;
  let client_mac = "00:00:00:00:00:00";
  let ap_mac = "00:00:00:00:00:00";
  let determineLoginType = "via";
  let adid = "00000000000000000000000000000000";

  if (isVia) {
    client_mac = params.mac !== undefined ? params.mac : client_mac;
    ap_mac = params.ap_mac !== undefined ? params.ap_mac : ap_mac;
    adid = params.adid !== undefined ? params.adid : adid;
    determineLoginType = "via";
  }
  if (isSmartzoneLogin) {
    client_mac =
      params.client_mac !== undefined ? params.client_mac : client_mac;
    ap_mac = params.mac !== undefined ? params.mac : ap_mac;
    determineLoginType = "smartzone";
  }
  if (isWLCLogin) {
    client_mac =
      params.client_mac !== undefined ? params.client_mac : client_mac;
    ap_mac = params.ap_mac !== undefined ? params.ap_mac : ap_mac;
    determineLoginType = "wlc";
  }

  return {
    client_mac,
    ap_mac,
    adid,
  };
};

export const useGetSublocation = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const location = useLocation();
  const pathname = isLocalhost
    ? location.pathname
        .replace(/^\/retail/, "")
        .replace(/^\/military/, "")
        .replace(/^\/ps/, "")
    : location.pathname;

  const firstSegment = pathname.split("/")[1];
  const match = firstSegment.match(/\.([^./]+)$/);
  const sublocation = match ? match[1] : "hotspot";
  return sublocation;
};

export const getBrowserLanguageCode = () => {
  const language =
    navigator.language || (navigator as any).userLanguage || "en";

  const languageCode = language.split("-")[0];

  return languageCode;
};

//get  query parameters before or after # in URL
export const getQueryParam = (param: string) => {
  param = param ?? "";
  const urlParts = window.location.href.split("#");
  let combinedParams = new URLSearchParams();

  // Check if there's a query string before the hash
  if (urlParts[0].includes("?")) {
    const baseQueryString = urlParts[0].split("?")[1];
    const baseParams = new URLSearchParams(baseQueryString);
    baseParams.forEach((value, key) => {
      key = key ?? "";
      combinedParams.set(key.toLowerCase(), value);
    });
  }

  // Check if there's a query string after the hash
  if (urlParts[1] && urlParts[1].includes("?")) {
    const hashQueryString = urlParts[1].split("?")[1];
    const hashParams = new URLSearchParams(hashQueryString);
    hashParams.forEach((value, key) => {
      key = key ?? "";
      combinedParams.set(key.toLowerCase(), value);
    });
  }

  return combinedParams.get(param.toLowerCase());
};

// construct URL
export const constructUrl = (
  path: string,
  venueId: string,
  locationSearch: string
) => {
  const newPath = venueId ? `/${venueId}${path}` : path;
  const search = locationSearch || "";
  return `${newPath}${search}`;
};

// get braintree token
export const getBraintreeToken = () => {
  const token = BRAINTREE_AUTH_TOKEN || "";
  if (!token) {
    console.error("Braintree token is not configured");
    return null;
  }
  return token;
};

export const generateAspNetLookingSessionId = () => {
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let sessionId = "";
  for (let i = 0; i < 24; i++) {
    sessionId += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return sessionId;
};

type ProductCodesFunction = (
  mainProductCode: string,
  additionalDevices?: Device[],
  modemProductCode?: string
) => string[];

export const formatProductCodes: ProductCodesFunction = (
  mainProductCode,
  additionalDevices = [],
  modemProductCode
) => {
  const productCodes: string[] = [mainProductCode];

  // Add modem product code if it exists
  if (modemProductCode) {
    productCodes.push(modemProductCode);
  }

  additionalDevices.forEach((device) => {
    const deviceCodes = device.product_code.split(", ");
    productCodes.push(...deviceCodes);
  });

  return productCodes;
};

// Retrieve Object of Internet Products, and return the free internet product object
export const getInternetFreeProduct = (products: any[]): any | undefined => {
  return products.find((product) => product.plan_name.toLowerCase() === "free");
};

// Redirect to welcome page with query params if they exist
export const redirectToWelcomePage = () => {
  const url = new URL(window.location.href);
  const basePath = url.pathname.endsWith("/")
    ? url.pathname
    : `${url.pathname}/`;
  const welcomePath = `${url.origin}${basePath}welcome`;

  window.location.href = url.search
    ? `${welcomePath}/${url.search}`
    : welcomePath;
};

export const getPageLoadtime = () => {
  const navigationEntry = performance.getEntriesByType(
    "navigation"
  )[0] as PerformanceNavigationTiming;
  if (navigationEntry) {
    const pageLoadTime =
      navigationEntry.domContentLoadedEventEnd - navigationEntry.startTime;
    return pageLoadTime > 0 ? pageLoadTime : undefined;
  }
  return 0;
};

export const formatISO8601DateTimeWithOffset = (
  date?: Date,
  format: string = "YYYY-MM-DDTHH:mm:ssZZ"
) => {
  date = !date ? new Date() : date;

  // Get timezone offset in minutes and convert to hours and minutes
  const tzOffset = date.getTimezoneOffset();
  const tzHours = Math.abs(Math.floor(tzOffset / 60))
    .toString()
    .padStart(2, "0");
  const tzMinutes = Math.abs(tzOffset % 60)
    .toString()
    .padStart(2, "0");
  const tzSign = tzOffset <= 0 ? "+" : "-";

  // Format the date components
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  // Return in ISO8601 format with timezone offset
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${tzSign}${tzHours}:${tzMinutes}`;
};

export const formatFriendlyErrorMessage = (error: any) => {
  if (!error) return;
  let errorValue = error.message ?? error;

  const isValidJSON = (error: string) => {
    try {
      JSON.parse(error);
      return true;
    } catch (e) {
      return false;
    }
  };

  if (isValidJSON(error)) {
    errorValue = JSON.parse(error)["message"];
  } else if (typeof error === "string") {
    // replace special chars with spaces
    errorValue = error.replace(/[-_:=\\\/{}\"\']/g, " ");
  }
  errorValue = errorValue.trim();
  // capitalize text
  errorValue = errorValue
    .split(" ")
    .map((word: string) => {
      return (word.charCodeAt(0) >= 48 && word.charCodeAt(0) <= 57) ||
        (word.charCodeAt(0) >= 97 && word.charCodeAt(0) <= 122)
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word;
    })
    .join(" ");
  return errorValue;
};

export const getVenueDetailsFromUrl = () => {
  const url = new URL(window.location.href);
  const currentPath = window.location.pathname;
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  // If there are 3 or more host parts, the first part is likely the subdomain
  const subdomain =
    hostname.split(".").length >= 3 && !isLocalhost
      ? hostname.split(".")[0]
      : "";

  // Get all path segments except the last one
  const pathParts = currentPath ? currentPath?.split("/").filter(Boolean) : "";

  const isSelfcarePath = isLocalhost
    ? !Object.values(WEB_PORTAL_PRODUCT_TYPES).includes(pathParts[0])
    : url.hostname.includes("my");

  // Default to first or second segment in case path is error/welcome/signup
  const pathSegment = isLocalhost ? pathParts[1] : pathParts[0];

  const productType = isSelfcarePath
    ? "selfcare"
    : isLocalhost
    ? pathParts[0]
    : hostname.split("-")[1]
    ? hostname.split("-")[0]
    : hostname.split(".")[0];

  // Get venueId and sublocation from the path
  const [venueId, sublocation] =
    !isSelfcarePath && pathSegment
      ? pathSegment.split(".")
      : [undefined, undefined];

  return { venueId, productType, subdomain, sublocation };
};

interface IcomeraUrlConfig {
  venueId?: string;
  sublocation?: string;
}

export const constructIcomeraUrls = ({
  venueId,
  sublocation,
}: IcomeraUrlConfig) => {
  const baseUrl = `${window.location.origin}/${venueId}${
    sublocation ? `.${sublocation}` : ""
  }`;
  const welcomeUrl = `${baseUrl}/welcome`;
  const errorUrl = `${baseUrl}/error`;
  const icomeraUrl = "https://www.ombord.info/hotspot/hotspot.cgi";
  const redirectUrl = `${icomeraUrl}?method=login&url=${welcomeUrl}&onerror=${errorUrl}`;

  return {
    welcomeUrl,
    errorUrl,
    icomeraUrl,
    redirectUrl,
  };
};

export const findSalesProduct = (modules: any[], identifier: string) => {
  // Convert identifier to lowercase and replace spaces with underscores for comparison
  const normalizedIdentifier = identifier.toLowerCase().replace(/\s+/g, "_");

  // Find the first sales-small module that matches the identifier
  const salesModule = modules.find((module) => {
    if (module.type !== "sales-small") return false;

    const productTitle = module.sale_product_details?.sales_title
      ?.toLowerCase()
      .replace(/\s+/g, "_");
    const productCode =
      module.sale_product_details?.product_code?.toLowerCase();

    return (
      productTitle === normalizedIdentifier ||
      productCode?.includes(normalizedIdentifier)
    );
  });

  return salesModule?.sale_product_details;
};

/**
 * Cleans up form values by removing empty/default values and mapping fields to schema format
 * Used ONLY on CustomFormModule.tsx to clean up data going to endpoint
 * @param {Record<string, any>} formValues - The raw form values from the form state
 * @param {string} endpoint - The endpoint identifier to determine schema requirements
 * @returns {Record<string, any>} The cleaned form values with only meaningful data
 */
/**
 * Formats a CPF number with progressive formatting as user types
 * @param input The input string to format
 * @returns Formatted CPF string (123.456.789-00)
 */
export const formatCPF = (input: string): string => {
  // Remove all non-digit characters
  const value = input.replace(/\D/g, "");

  // Return early if no digits
  if (value.length === 0) {
    return "";
  }

  // Format progressively based on length
  if (value.length <= 3) {
    return value;
  } else if (value.length <= 6) {
    return value.substring(0, 3) + "." + value.substring(3);
  } else if (value.length <= 9) {
    return (
      value.substring(0, 3) +
      "." +
      value.substring(3, 6) +
      "." +
      value.substring(6)
    );
  } else {
    // Limit to 11 digits and apply full formatting
    const limitedValue = value.substring(0, 11);
    return (
      limitedValue.substring(0, 3) +
      "." +
      limitedValue.substring(3, 6) +
      "." +
      limitedValue.substring(6, 9) +
      "-" +
      limitedValue.substring(9)
    );
  }
};

export const cleanupFormValues = (
  formValues: Record<string, any>,
  endpoint: string
): Record<string, any> => {
  const cleanedValues: Record<string, any> = {};

  switch (endpoint.toLowerCase()) {
    case "glidepath":
      // Always include email if it exists
      if (formValues.email && formValues.email.trim() !== "") {
        cleanedValues.email = formValues.email.trim();
      }

      // Always include firstName if it exists and is not empty
      if (formValues.firstName && formValues.firstName.trim() !== "") {
        cleanedValues.firstName = formValues.firstName.trim();
      }

      // Always include lastName if it exists and is not empty
      if (formValues.lastName && formValues.lastName.trim() !== "") {
        cleanedValues.lastName = formValues.lastName.trim();
      }

      // Map zipCode/zipCodeRfc to zip (prefer zipCode over zipCodeRfc)
      const zipValue = formValues.zipCode || formValues.zipCodeRfc;
      if (zipValue && zipValue.trim() !== "") {
        cleanedValues.zip = zipValue.trim();
      }

      // For glidepath, use formValues.optOut directly
      if (typeof formValues.optOut !== "undefined") {
        cleanedValues.opt_out = formValues.optOut;
      }

      // Add optional glidepath-specific fields if they exist
      if (formValues.program && formValues.program.trim() !== "") {
        cleanedValues.program = formValues.program.trim();
      }

      if (
        formValues.enrollmentSource &&
        formValues.enrollmentSource.trim() !== ""
      ) {
        cleanedValues.enrollmentSource = formValues.enrollmentSource.trim();
      }

      if (formValues.airport && formValues.airport.trim() !== "") {
        cleanedValues.airport = formValues.airport.trim();
      }

      break;

    case "rfc_mailchimp":
      // Handle RFC mailchimp-specific schema requirements - only email, country, and zip
      // Always include email if it exists
      if (formValues.email && formValues.email.trim() !== "") {
        cleanedValues.email = formValues.email.trim();
      }

      // Include country if it's selected and not the default placeholder
      if (
        formValues.country &&
        formValues.country !== "Where are you visiting from?" &&
        formValues.country.trim() !== ""
      ) {
        cleanedValues.country = formValues.country;
      }

      // Map zipCode/zipCodeRfc to zip (prefer zipCode over zipCodeRfc) - only if exists
      const rfcZipValue = formValues.zipCode || formValues.zipCodeRfc;
      if (rfcZipValue && rfcZipValue.trim() !== "") {
        cleanedValues.zip = rfcZipValue.trim();
      }

      break;

    case "access_code_bwpromo":
      // Handle access_code_bwpromo - only include access_code
      if (formValues.access_code && formValues.access_code.trim() !== "") {
        cleanedValues.access_code = formValues.access_code.trim();
      }

      break;

    case "lhrenroll":
      // Handle lhrenroll schema - title, titleNum, firstName, lastName, opt_out
      if (formValues.title && formValues.title.trim() !== "") {
        cleanedValues.title = formValues.title.trim();
      }

      if (formValues.email && formValues.email.trim() !== "") {
        cleanedValues.email = formValues.email.trim();
      }

      if (formValues.titleNum && formValues.titleNum.trim() !== "") {
        cleanedValues.titleNum = formValues.titleNum.trim();
      }

      if (formValues.firstName && formValues.firstName.trim() !== "") {
        cleanedValues.firstName = formValues.firstName.trim();
      }

      if (formValues.lastName && formValues.lastName.trim() !== "") {
        cleanedValues.lastName = formValues.lastName.trim();
      }

      // Map optOut to opt_out (always include boolean values)
      if (typeof formValues.optBlobChecked !== "undefined") {
        cleanedValues.opt_out = formValues.optBlobChecked;
      }

      break;

    default:
      // For unknown endpoints, use the original generic logic
      // Always include email if it exists
      if (formValues.email && formValues.email.trim() !== "") {
        cleanedValues.email = formValues.email.trim();
      }

      // Always include firstName if it exists and is not empty
      if (formValues.firstName && formValues.firstName.trim() !== "") {
        cleanedValues.firstName = formValues.firstName.trim();
      }

      // Always include lastName if it exists and is not empty
      if (formValues.lastName && formValues.lastName.trim() !== "") {
        cleanedValues.lastName = formValues.lastName.trim();
      }

      // Include title if it exists and is not empty
      if (formValues.title && formValues.title.trim() !== "") {
        cleanedValues.title = formValues.title.trim();
      }

      // Map zipCode/zipCodeRfc to zip (prefer zipCode over zipCodeRfc)
      const defaultZipValue = formValues.zipCode || formValues.zipCodeRfc;
      if (defaultZipValue && defaultZipValue.trim() !== "") {
        cleanedValues.zip = defaultZipValue.trim();
      }

      // Map optOut to opt_out (always include boolean values)
      if (typeof formValues.optOut === "boolean") {
        cleanedValues.opt_out = formValues.optOut;
      }

      // Include country if it's selected and not the default placeholder
      if (
        formValues.country &&
        formValues.country !== "Where are you visiting from?" &&
        formValues.country.trim() !== ""
      ) {
        cleanedValues.country = formValues.country;
      }

      // Include access_code if it exists and is not empty
      if (formValues.access_code && formValues.access_code.trim() !== "") {
        cleanedValues.access_code = formValues.access_code.trim();
      }

      // Include access_pass if it exists and is not empty
      if (formValues.access_pass && formValues.access_pass.trim() !== "") {
        cleanedValues.access_pass = formValues.access_pass.trim();
      }

      console.warn(
        `Unknown endpoint: ${endpoint}. Using default cleanup logic.`
      );
      break;
  }

  return cleanedValues;
};
